import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useOrgKey } from '@/hooks/auth/useOrgKey';
import type { ProfileStatsResponse } from '@/lib/types';

export function useProfileStats(userId: string | undefined, year?: number) {
  const orgKey = useOrgKey();
  return useQuery<ProfileStatsResponse>({
    queryKey: [...queryKeys.profileStats(orgKey, userId!, year!)],
    queryFn: () => api.getProfileStats(userId, year),
    enabled: !!userId,
  });
}
